export const selectObjectivePanelDetails = (state) => state.objectiveDetailsPanel;
export const selectLatestObjectivePanelDetails = (state) => state.objectiveDetailsPanel.callbackInfo.slice(-1)?.[0];
